import { QueryClient } from "react-query";

export const queryCache = new QueryClient();
